/**
 * Habit timeline — mobile one-at-a-time slider with page dots.
 * Desktop keeps its own CSS grid layout untouched; on mobile the track
 * becomes a scroll-snap carousel and this file just keeps the dots in sync
 * with whichever slide is actually in view, and scrolls to a slide when its
 * dot is clicked. No dependency on the site's Embla carousel component —
 * this section's markup predates it, and native scroll-snap + an
 * IntersectionObserver is enough for a two-to-four-slide list like this.
 */
(function () {
  function init(track) {
    var list = track.querySelector('.habit__list');
    var items = Array.prototype.slice.call(track.querySelectorAll('.habit__item'));
    var dots = Array.prototype.slice.call(track.querySelectorAll('[data-habit-dot]'));
    if (!list || !items.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActive(items.indexOf(entry.target));
          }
        });
      },
      { root: list, threshold: 0.6 }
    );
    items.forEach(function (item) { observer.observe(item); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }

  document.querySelectorAll('[data-habit-track]').forEach(init);
})();
